export default __webpack_public_path__ + "static/media/rbitrage.77046d4f.png";